var forms = {

	init: function () {
		forms.datepicker(); // moved to fix datepicker quickly
		forms.autosubmit(); // moved to fix auto submit quickly
		try { forms.loaderSubmit(); } catch (e) { console.log(e); }
		try { forms.maxLength(); } catch (e) { console.log(e); }
		try { forms.urlSubmit(); } catch (e) { console.log(e); }
		try { forms.showIf.init(); } catch (e) { console.log(e); }
		try { forms.swatch.init(); } catch (e) { console.log(e); }
		try { forms.checkoutSubmitValidation(); } catch (e) { console.log(e); }
	},

	loaderSubmit: function () {
		$('form.js-loader-submit:not(.js-loader-submit-done)').each(function () {
			var form = $(this);

			// submit
			form.on('submit', function () {
				// check valid
				if (form.valid()) {
					// show loader
					popups.loader();

					var watchdog = setTimeout(function () {
						popups.loader(true);
						popups.confirm('Error', 'This is taking longer than expected. Please check your connection and try again in a moment.', '', true);

						claimDiagnostics.report({
							context: 'form-submit',
							path: form.attr('action') || location.pathname,
							method: (form.attr('method') || 'POST').toUpperCase(),
							vin: form.find('[name="Vin"]').val() || null,
							errorType: 'client-timeout'
						});
					}, 60000);

					$(window).one('pagehide', function () {
						clearTimeout(watchdog);
					});

					// submit
					return true;
				}
				return false;
			});

			// done
			form.addClass('js-loader-submit-done');
		});
	},

	urlSubmit: function () {

		$('select.js-url-submit:not(.js-url-submit-done)').each(function () {
			var input = $(this);

			// change
			input.off('change').on('change', function () {
				location.href = input.val();
				return false;
			});

			// done
			input.addClass('js-url-sibmit-done');
		});

	},

	autosubmit: function () {

		$('.js-autosubmit:not(.js-autosubmit-done)').each(function () {
			var input = $(this);
			var form = input.closest('form');
			var submitTimer;

			input.on('change', function () {

				if (submitTimer) {
					clearTimeout(submitTimer);
				}

				submitTimer = setTimeout(function () {
					form.submit();
				}, 500);

			});

			// done
			input.addClass('js-autosubmit-done');
		});
	},

	maxLength: function () {
		$('input[data-maxlength]:not(.js-max-done), textarea[data-maxlength]:not(.js-max-done)').each(function () {
			var input = $(this);
			var count = $(input.attr('data-maxlength-info'));
			// get limit
			var limit = parseInt(input.attr('data-maxlength'), 10);
			// limit on keyup, click, paste or blur
			input.on('keyup click paste blur', function () {
				var remaining = limit - input.val().length;
				if (remaining <= 0) {
					input.val(input.val().substr(0, limit));
					remaining = 0;
				}
				if (remaining <= 10 && limit >= 20) {
					count.parent().addClass('highlight-red');
				}
				else {
					count.parent().removeClass('highlight-red');
				}
				if (remaining > 10 && remaining <= 20 && limit >= 30) {
					count.parent().addClass('highlight-orange');
				}
				else {
					count.parent().removeClass('highlight-orange');
				}
				count.text(remaining);
			}).blur();
			// done
			input.addClass('js-max-done');
		});
	},

	datepicker: function () {
		$('input.js-datepicker:not(.js-datepicker-done)').each(function () {
			var input = $(this);

			// init
			input.datepicker({
				dateFormat: 'dd/mm/yy'
			});

			// min
			if (typeof input.attr('data-min') != 'undefined') {
				input.datepicker('option', 'minDate', input.attr('data-min'));
			}

			// max
			if (typeof input.attr('data-max') != 'undefined') {
				input.datepicker('option', 'maxDate', input.attr('data-max'));
			}

			// done
			input.addClass('js-datepicker-done');
		});
	},

	showIf: {

		init: function () {
			forms.showIf.checks();
			forms.showIf.radios();
			forms.showIf.dropdowns();
		},

		disableFormElements: function (parent) {
			parent.find("input,select").attr('disabled', 'disabled');
		},

		enableFormElements: function (parent) {
			parent.find("input,select").removeAttr('disabled');
		},

		checks: function () {
			$('.form-checks input[data-show-if]:checkbox:not(.js-show-if-done)').each(function () {
				var input = $(this);
				var reverse = input.attr('data-reverse') === 'true' ? true : false;
				var ref = input.attr('data-show-if').split(',');

				var check = function () {
					if (!input.is(':checked') && reverse) {
						// show
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).show();
							forms.showIf.enableFormElements($(ref[i]));
						}
					}
					else if (input.is(':checked') && reverse) {
						// hide
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).hide();
							forms.showIf.disableFormElements($(ref[i]));
						}
					}
					else if (input.is(':checked')) {
						// show
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).show();
							forms.showIf.enableFormElements($(ref[i]));
						}
					}
					else {
						// hide
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).hide();
							forms.showIf.disableFormElements($(ref[i]));
						}
					}
				};

				// change functionality
				input.on('change', function () {
					check();
				});

				// on load
				check();

				// done
				input.addClass('js-show-if-done');
			});
		},

		radios: function () {
			$('.form-checks:not(.js-show-if-done) input[data-show-if]:radio').closest('.form-checks').each(function () {
				var wrapper = $(this);

				// change functionality
				wrapper.find('input').each(function () {
					var input = $(this);
					var group = input.attr('name');

					var check = function (opt, show) {
						var ref = opt.attr('data-show-if').split(',');
						if (show) {
							for (var i = 0; i < ref.length; i++) {
								$(ref[i]).show();
								forms.showIf.enableFormElements($(ref[i]));
							}
						}
						else {
							for (var i = 0; i < ref.length; i++) {
								$(ref[i]).hide();
								forms.showIf.disableFormElements($(ref[i]));
							}
						}
					};

					// on change
					input.on('change', function () {
						// hide non-selected
						$('input[name="' + group + '"][data-show-if]:not(:checked)').each(function () {
							var opt = $(this);
							// hide
							check(opt, false);
						});
						// show selected
						$('input[name="' + group + '"][data-show-if]:checked').each(function () {
							var opt = $(this);
							// show
							check(opt, true);
						});
					});

					// on load
					if (input.is('[data-show-if]:not(:checked)')) {
						var opt = $(this);
						// hide
						check(opt, false);
					}
					if (input.is('[data-show-if]:checked')) {
						var opt = $(this);
						// show
						check(opt, true);
					}

				});

				// done
				wrapper.addClass('js-show-if-done');
			});
		},

		dropdowns: function () {
			$('select:not(.js-show-if-done) option[data-show-if]').closest('select').each(function () {
				var select = $(this);

				var check = function (opt, show) {
					var ref = opt.attr('data-show-if').split(',');
					if (show) {
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).show();
							forms.showIf.enableFormElements($(ref[i]));
						}
					}
					else {
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).hide();
							forms.showIf.disableFormElements($(ref[i]));
						}
					}
				}

				// change functionality
				select.on('change', function () {
					// hide non-selected
					select.find('option[data-show-if]').each(function () {
						var opt = $(this);
						if (opt.is(':selected')) {
							check(opt, true);
						}
						else {
							check(opt, false);
						}
					});
				});

				// on load
				select.find('option[data-show-if]').each(function () {
					var opt = $(this);
					if (opt.is(':selected')) {
						check(opt, true);
					}
					else {
						check(opt, false);
					}
				});

				// done
				select.addClass('js-show-if-done');
			});
		}

	},

	swatch: {

		init: function () {
			$('select[data-swatch]:not(.js-swatch-done)').each(function () {
				var input = $(this);
				var wrapper = $(input.attr('data-swatch'));
				var items = wrapper.find('.js-swatch');

				if (!items.length) return;

				// init
				input.addClass('offscreen');

				// change
				input.on('change', function() {
					forms.swatch.update(input);
				});

				// click
				items.off('click').on('click', function () {
					input.val($(this).attr('data-val')).change();
					return false;
				});

				// done
				input.addClass('js-swatch-done');
			});

		},

		update: function (input) {
			var wrapper = $(input.attr('data-swatch'));
			var items = wrapper.find('.js-swatch');
			// reset
			items.removeClass('unavailable active');
			// set active
			items.filter('[data-val="' + input.val() + '"]').addClass('active');
			// set unavailable
			input.find('.unavailable').each(function () {
				items.filter('[data-val="' + $(this).attr('value') + '"]').addClass('unavailable');
			});
			// set value
			wrapper.find('.js-swatch-value').text(input.find(':selected').text());
		}

	},

	checkoutSubmitValidation: function () {
		if (!$('.js-vin-form').length) {
			return;
		}
		$('.js-checkout-submit').on('click', function (e) {

			var submitForm = true;
			$('.js-vin-form').each(function () {
				$(this).validate();
				if (!$(this).valid()) {
					submitForm = false;
				}
			});

			if (!submitForm) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $('.js-vin-form .input-validation-error').offset().top - 50
				}, 500);
				$('.js-vin-input.input-validation-error').focus();
			}

		});
	}

};

$(function () {
	forms.init();
	$(document).ajaxComplete(function () {
		forms.init();
	});
});
